<template>
	<div>
		<v-tabs
			v-model="activeTab"
			:color="themeInputColor"
			dark
			slider-color="yellow"
			grow
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#tab-' + i"
				:ripple="false"
				class="px-3"
				@click="() => handleTabChange(tab)"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="activeTab">
			<v-tab-item value="tab-0">
				<v-flex justify-center row py-1>
					<v-flex row>
						<v-card
							hover
							class="scheme-card"
							v-for="scheme in allSchemes"
							:key="scheme.id"
						>
							<v-img :src="scheme.imageURL" alt="scheme" />
						</v-card>
					</v-flex>
					<div
						class="subheading text-center"
						v-if="!allSchemes.length && !isFetchingSchemes"
					>
						No Schemes Available
					</div>
				</v-flex>
			</v-tab-item>
			<v-tab-item value="tab-1">
				<div style="display:flex;" class="mb-4">
					<v-select
						:items="years"
						label="Select Year"
						hide-details
						v-model="selectedYear"
						@change="val => handleDropDownChange('yr', val)"
						class="px-2"
					></v-select
					><v-select
						:items="months"
						label="Select Month"
						hide-details
						v-model="selectedMonth"
						@change="val => handleDropDownChange('mo', val)"
						class="px-2"
					></v-select>
				</div>
				<div
					style="height: 75vh"
					color="#EDF0F7"
					class="bg"
					v-infinite-scroll="
						() => (schemeRewardsOffset ? loadMoreData() : {})
					"
					infinite-scroll-disabled="isFetchingSchemes"
					infinite-scroll-throttle-delay="200"
				>
					<v-card
						style="display:flex;justify-content: space-between;"
						class="mb-2"
						v-for="item in schemeRewards"
						:key="item.id"
					>
						<div class="pa-2 alignInColumn">
							<div class="font-weight-bold mb-2">
								{{ item.retailerName || "-" }}
							</div>
							<div>
								Total Payout ₹
								{{ item.amount || "-" }}
							</div>
						</div>
						<div class="pa-2">
							<v-btn
								color="primary"
								@click="showPayment(item)"
								:disabled="item.status === 'PAID' || isRetailer"
								style="min-width: 150px;"
								>{{
									item.status === "PAID"
										? "Paid"
										: isRetailer
										? "Pending"
										: "Pay Now"
								}}</v-btn
							>
						</div>
					</v-card>
				</div>
				<v-dialog
					v-model="showPopup"
					v-if="!isRetailer"
					persistent
					max-width="600px"
				>
					<v-card>
						<v-card-title>
							<span class="headline">Payment Mode</span>
						</v-card-title>
						<div class="pa-2 alignInColumn">
							<div>Select Payment Mode</div>
							<div>
								<v-radio-group
									v-model="selectedModeOfPayment"
									row
								>
									<v-radio
										v-for="text in modeOfPayment"
										:key="text"
										:label="text"
										:value="text"
										@change="
											val => (selectedModeOfPayment = val)
										"
									></v-radio>
								</v-radio-group>
							</div>
							<v-dialog
								width="600px"
								persistent
								v-model="transferJeet11Dialog"
							>
								<div>
									<transfer-money
										model="transferJeet11Dialog"
										:themeInputColor="themeInputColor"
										:searchingJeet11User="
											searchingJeet11User
										"
										:searchedUser="searchedUser"
										:payingJeet11User="
											pay11Jeet11UserLoading
										"
										:forgetMpin="forgetMpin"
										:jeet11WalletBalance="
											jeet11PartnerDetails.walletBalance
										"
										@SEARCH_USER="searchJeet11User"
										@CLOSE_MODAL="closeModal"
										@RESET_SEARCHED_JEET11_USER="
											resetJeet11SearchedUser
										"
										@CONFIRM_AND_PAY_TO_JEET11_USER="
											confirmAndPayJeet11User
										"
										:isRummyOptionSelected="false"
										:additionalParam="additionalParam"
										:prefetchedAmount="
											selectedRetailer.amount + ''
										"
										:prefetchedRetailerPhoneNo="
											(
												selectedRetailer.retailerPhoneNo +
												''
											).slice(2)
										"
										:userId="selectedRetailer.userId"
									/>
								</div>
							</v-dialog>
							<generate-mpin
								@CLOSE_MODAL="closeModal"
								model="generateMpinDialog"
								v-if="generateMpinDialog"
								:themeInputColor="themeInputColor"
							/>
							<div v-if="selectedModeOfPayment !== 'Cash'">
								<div
									style="display:flex;justify-content:space-between"
								>
									<div>Your Wallet Balance:</div>
									<div>
										₹{{
											jeet11PartnerDetails.walletBalance
										}}
									</div>
								</div>
							</div>
							<div v-if="selectedModeOfPayment !== 'Cash'">
								<div
									style="display:flex;justify-content:space-between"
								>
									<div>
										Payment to
										{{ selectedRetailer.retailerName }}:
									</div>
									<div>₹{{ selectedRetailer.amount }}</div>
								</div>
							</div>
						</div>
						<div style="display:flex;justify-content:center">
							<v-btn
								class="white--text"
								@click="showPopup = false"
								color="error"
								>Close</v-btn
							>
							<v-btn
								class="white--text"
								@click="handleTransferClick"
								:color="themeInputColor"
								>{{
									selectedModeOfPayment !== "Cash"
										? "Transfer Now"
										: "Payment Done"
								}}</v-btn
							>
						</div>
					</v-card></v-dialog
				>
			</v-tab-item>
		</v-tabs-items>
		<div class="text-center" v-if="isFetchingSchemes">
			<v-progress-circular
				indeterminate
				v-bind:size="30"
				:color="themeInputColor"
			/>
		</div>
	</div>
</template>

<script>
import infiniteScroll from "vue-infinite-scroll";
import { themeInputColor } from "@/utils";
import { mapState } from "vuex";
import {
	FETCH_RETAIL_SCHEMES,
	FETCH_SCHEME_REWARDS,
	FETCH_JEET11_USER_BY_PHONE,
	PAY_JEET11_USER,
	RESET_JEET11_SEARCHED_USER,
	TRANSFER_SCHEME_REWARD_CASH
} from "../../store/action-types";
import TransferMoney from "./transfer-money";
import GenerateMPIN from "../GenerateMPIN";

export default {
	name: "Schemes",
	data() {
		return {
			themeInputColor,
			allSchemes: [],
			isFetchingSchemes: false,
			activeTab: "tab-0",
			tabs: [{ name: "Current Month" }, { name: "History" }],
			years: [],
			months: [],
			selectedYear: 0,
			selectedMonth: 0,
			isRetailer: false,
			schemeRewards: [],
			showPopup: false,
			selectedModeOfPayment: "Jeet11 Wallet",
			modeOfPayment: ["Jeet11 Wallet", "Cash"],
			selectedRetailer: {},
			transferJeet11Dialog: false,
			searchingJeet11User: false,
			pay11Jeet11UserLoading: false,
			generateMpinDialog: false,
			additionalParam: "",
			schemeRewardsOffset: "",
			searchedUser: {}
		};
	},
	directives: { infiniteScroll },
	components: {
		"transfer-money": TransferMoney,
		"generate-mpin": GenerateMPIN
	},
	mounted() {
		this.fetchSchemes();
		this.resetJeet11SearchedUser();
		const date = new Date();
		const now = new Date().getUTCFullYear();
		const years = Array(now - (now - 20))
			.fill("")
			.map((__, idx) => now - idx);
		this.years = years;
		this.months = Array(12)
			.fill("")
			.map((__, idx) =>
				new Date(date.getYear(), idx).toLocaleDateString("default", {
					month: "long"
				})
			);
		this.selectedYear = this.years[0];
		this.selectedMonth = this.months[0];
		this.isRetailer = this.jeet11PartnerDetails.userType === "dstrRetail";
	},
	computed: {
		...mapState({
			storeType: state => state.jeet11.jeet11PartnerDetails.userType,
			state: state => state.retail.retailerData.state,
			jeet11PartnerDetails: state => state.jeet11.jeet11PartnerDetails
		})
	},
	methods: {
		fetchSchemes() {
			if (this.isFetchingSchemes) return;
			this.isFetchingSchemes = true;
			this.$store
				.dispatch(FETCH_RETAIL_SCHEMES.dispatch, {
					state: this.state,
					userType: this.storeType
				})
				.then(schemes => {
					this.allSchemes = schemes || [];
				})
				.finally(() => {
					this.isFetchingSchemes = false;
				});
		},
		loadMoreData() {
			this.fetchSchemesRewards(false);
		},
		fetchSchemesRewards(fromStart = true) {
			const date = new Date();
			this.isFetchingSchemes = true;
			this.$store
				.dispatch(FETCH_SCHEME_REWARDS.dispatch, {
					mo:
						new Date(
							Date.parse(
								this.selectedMonth +
									`${date.getDate()}, ${date.getFullYear()}`
							)
						).getMonth() + 1,
					yr: this.selectedYear,
					isRetailer: +this.isRetailer,
					...(fromStart ? {} : { of: this.schemeRewardsOffset })
				})
				.then(data => {
					this.schemeRewards = fromStart
						? data.schemeRewards
						: [...this.schemeRewards, ...data.schemeRewards];
					this.schemeRewardsOffset = data.nextOffset;
				})
				.finally(() => {
					this.isFetchingSchemes = false;
				});
		},
		transferSchemeRewardCash(id) {
			this.isFetchingSchemes = true;
			this.$store
				.dispatch(TRANSFER_SCHEME_REWARD_CASH.dispatch, {
					schemeRewardId: id
				})
				.then(() => {
					this.showPopup = false;
					this.selectedRetailer = {};
					this.fetchSchemesRewards();
				})
				.finally(() => {
					this.isFetchingSchemes = false;
				});
		},
		handleDropDownChange(type, val) {
			if (type === "yr") this.selectedYear = val;
			else this.selectedMonth = val;
			this.fetchSchemesRewards();
		},
		showPayment(item) {
			this.showPopup = true;
			this.selectedRetailer = { ...item };
		},
		searchJeet11User(payload) {
			if (!this.searchingJeet11User) {
				this.searchingJeet11User = true;
				this.$store
					.dispatch(FETCH_JEET11_USER_BY_PHONE.dispatch, payload)
					.catch(() => {})
					.then(() => (this.searchingJeet11User = false));
			}
		},
		confirmAndPayJeet11User(payload) {
			if (!this.pay11Jeet11UserLoading) {
				this.pay11Jeet11UserLoading = true;
				this.$store
					.dispatch(PAY_JEET11_USER.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.pay11Jeet11UserLoading = false;
						this.transferJeet11Dialog = false;
						this.searchedUser = {};
						this.showPopup = false;
						this.fetchSchemesRewards();
					});
			}
		},
		forgetMpin() {
			this.generateMpinDialog = true;
		},
		closeModal(payload) {
			this[payload] = false;
		},
		resetJeet11SearchedUser() {
			this.$store.dispatch(RESET_JEET11_SEARCHED_USER.dispatch);
		},
		handleTransferClick() {
			if (this.selectedModeOfPayment !== "Cash") {
				this.additionalParam = this.selectedRetailer.id;
				this.transferJeet11Dialog = true;
				this.searchedUser = {
					teamName: this.selectedRetailer.retailerName
				};
			} else this.transferSchemeRewardCash(this.selectedRetailer.id);
		},
		handleTabChange(val) {
			if (val.name === "History") this.fetchSchemesRewards();
			else this.fetchSchemes();
		}
	}
};
</script>
<style scoped>
.scheme-card {
	border-radius: 6px;
	margin: 1em 0;
}
.alignInColumn {
	display: flex;
	flex-direction: column;
}
</style>
